/*! Goldtop PDP v2 - EXTENSIONS. Loaded after assets/gt-pdp-v2.js.

    WHY THIS FILE EXISTS. The controller is 85KB of one closure, and a theme
    write has to carry the whole file in a single relay, which is past what this
    tooling can place (claude/pdp-v2-payload-ceiling-9sep.md). Parts five to nine
    of the stylesheet exist for exactly that reason. This is the same move for
    JavaScript: additions that need no access to the controller's internals live
    here, where they cost 30KB to change instead of 85KB.

    IT IS A PATCH LAYER, NOT A HOME. Everything here should be folded into the
    controller the next time that file is opened properly - through the Shopify
    code editor, which has no such ceiling - and this file emptied. Each section
    names the function it belongs beside when that happens.

    NOTHING HERE REACHES INTO THE CONTROLLER. It listens to the DOM and writes to
    the DOM, exactly as the controller does. Where it deliberately pre-empts a
    controller behaviour, the section says so and says why.

    PURE ASCII, on purpose. Working rule 18: the theme-file connector has mangled
    non-ASCII twice.
*/
(function () {
  "use strict";

  var MQ = window.matchMedia("(max-width: 768px)");
  var HTML = document.documentElement;

  function q(s, r) { try { return (r || document).querySelector(s); } catch (e) { return null; } }
  function qa(s, r) { try { return [].slice.call((r || document).querySelectorAll(s)); } catch (e) { return []; } }
  function txt(el) { return el ? (el.textContent || "").replace(/\s+/g, " ").trim() : ""; }
  function meta() { return q(".product-single__meta"); }

  function optWrappers() {
    return qa(".variant-wrapper", meta() || document).filter(function (w) {
      return !!q('input[type="radio"], select', w);
    });
  }
  function labelText(w) {
    var l = q(".variant__label", w);
    if (!l) return "";
    var t = "", n = l.childNodes, i;
    for (i = 0; i < n.length; i++) if (n[i].nodeType === 3) t += n[i].nodeValue;
    return (t || "").replace(/\s+/g, " ").replace(/[:\s]+$/, "").trim();
  }
  function wrapperNamed(name) {
    if (!name) return null;
    var want = name.toLowerCase(), ws = optWrappers(), i;
    for (i = 0; i < ws.length; i++) if (labelText(ws[i]).toLowerCase() === want) return ws[i];
    for (i = 0; i < ws.length; i++) if (labelText(ws[i]).toLowerCase().indexOf(want) > -1) return ws[i];
    return null;
  }
  function sizeWrapper() {
    var ws = optWrappers(), i;
    for (i = 0; i < ws.length; i++) if (/size/i.test(labelText(ws[i]))) return ws[i];
    var cw = colourWrapper();
    for (i = 0; i < ws.length; i++) if (ws[i] !== cw) return ws[i];
    return null;
  }
  function colourWrapper() {
    var ws = optWrappers(), i;
    for (i = 0; i < ws.length; i++) if (/colou?r/i.test(labelText(ws[i]))) return ws[i];
    return null;
  }
  function chosenIn(w) {
    if (!w) return "";
    var c = q("input:checked", w);
    if (c) {
      var l = c.id ? q('label[for="' + c.id + '"]', w) : null;
      return ((l && (l.getAttribute("data-value") || l.textContent)) || c.value || "").trim();
    }
    var s = q("select", w);
    return s ? (s.value || "").trim() : "";
  }
  /* The checked radio's VALUE, which is the currency choose() and radioFor()
     deal in. chosenIn() above prefers the label's text, which is what the
     controller compares against - the two are not always the same string, and
     mixing them is a bug waiting to happen. */
  function chosenValue(w) {
    var c = w ? q("input:checked", w) : null;
    return c ? (c.value || "").trim() : "";
  }
  function radioFor(w, val) {
    var ins = qa('input[type="radio"]', w), i;
    for (i = 0; i < ins.length; i++) if ((ins[i].value || "").trim() === val) return ins[i];
    return null;
  }

  /* ====================================================================
     0. THE AVAILABILITY MATRIX, READ FROM THE ONE PLACE THAT HAS IT

     Every section below needs the same fact: for a given combination of
     option values, is there a variant and can it be bought? Until now each
     one guessed at it from something downstream - the button's wording, a
     class the controller had set, an input's disabled property - and each of
     those guesses has been wrong at least once.

     There is no [data-product-json] on this theme. What there IS, on every
     product page, is the fallback product <select> that Impulse renders for
     no-JS. It carries one <option> per variant, text of the form

       S - 38" to 40" / Classic Ivory - Sold Out
       M - 40" to 42" / Track Gold - GBP 55.00

     and - this is the part that matters - `disabled` is true exactly when the
     variant cannot be bought. That is Shopify's own answer, rendered server
     side, complete for every combination, and it does not depend on any
     script having run.

     IT IS ALSO THE ONLY SOURCE THAT KNOWS ABOUT LOCATIONS. The Admin API
     reported the Neck Tube's Chequered as available with four in stock; the
     storefront marked it Sold Out, and the storefront was right - those four
     are at a location the online store does not sell from. Anything that
     decides what a shopper can buy has to read what the shopper is served.

     GENERIC BY CONSTRUCTION. The option values are never parsed out of that
     text. Instead the values we already know - from the radios - are JOINED
     in option order and matched as a prefix. So a value containing " - "
     (every size here) or "&" (every style here) needs no escaping, and the
     same code covers one, two or three options under any names.

     It is also self-checking. comboOption() on the CURRENT selection must
     resolve before any caller trusts the matrix; if it does not, the caller
     falls back to what it did before rather than marking every chip sold out.
     Failing to a stale mark is survivable. Failing to "nothing is in stock"
     is not.
     ==================================================================== */
  function productSelect() {
    return q("select[name='id']", meta() || document) ||
           q("select#ProductSelect") ||
           q("select[name='id']");
  }
  function optText(o) { return (o.textContent || "").replace(/\s+/g, " ").trim(); }

  function comboOption(sel, vals) {
    if (!sel || !sel.options || !vals || !vals.length) return null;
    var prefix = vals.join(" / "), opts = sel.options, i, t, rest;
    for (i = 0; i < opts.length; i++) {
      t = optText(opts[i]);
      if (t === prefix) return opts[i];
      if (t.indexOf(prefix) === 0) {
        rest = t.slice(prefix.length);
        if (/^\s*-\s/.test(rest)) return opts[i];
      }
    }
    return null;
  }

  function currentVals() {
    var ws = optWrappers(), vals = ws.map(chosenIn), i;
    for (i = 0; i < vals.length; i++) if (!vals[i]) return [];
    return vals;
  }

  function matrix() {
    var sel = productSelect();
    if (!sel) return null;
    var vals = currentVals();
    if (!vals.length) return null;
    if (!comboOption(sel, vals)) return null;
    return { sel: sel, vals: vals, ws: optWrappers() };
  }

  /* Select a value even when the theme has disabled that radio. A disabled input
     cannot be clicked by a user but CAN be set programmatically, so the label
     click is tried first and the direct set is the fallback that actually works
     in the sold-out case. This is the controller's pickOption() minus its
     `if (inp.disabled) return false` guard, which is the line that made a
     sold-out value unselectable. */
  function choose(w, val) {
    if (!w || !val) return false;
    var inp = radioFor(w, val);
    if (!inp) return false;
    if (inp.checked) return true;
    var y = window.pageYOffset, x = window.pageXOffset;
    function keep() { if (window.pageYOffset !== y) window.scrollTo(x, y); }
    var lab = inp.id ? q('label[for="' + inp.id + '"]', w) : null;
    if (lab && !inp.disabled) lab.click();
    if (!inp.checked) {
      inp.checked = true;
      inp.dispatchEvent(new Event("click", { bubbles: true }));
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    }
    try { inp.blur(); } catch (e) {}
    keep(); requestAnimationFrame(keep); setTimeout(keep, 0); setTimeout(keep, 120);
    return true;
  }

  /* ====================================================================
     1. holdStyle - the selection survives a size change, for EVERY option

     The complaint: on the MX Jersey, choose Gold & Navy then choose XL and
     the style jumps to one that is in stock. XL / Gold & Navy EXISTS as a
     variant and is simply sold out, so this is not Shopify falling back for
     want of a variant - something on the page moves the selection.

     WHY IT PINS RATHER THAN RESTORES. The first version held the selection by
     putting it back, and Joe's verdict was "very janky ... switching from an
     out of stock option to an in stock option and then flicking back", which
     is precisely what putting it back looks like. Instrumented on the MX
     Jersey, times relative to the tap:

       t = 42ms   theme.js sets MX Black & Grey = true and clears the rest
       t = 88ms   our restore fires and clicks the Gold & Navy label
       t = 95ms   theme.js re-runs off that click and puts it back

     Three frames of wrong state, animated by the chip's CSS transition. No
     restore can win that race: the move is asynchronous, so by the time it
     happens the change event has finished and there is no earlier hook left.
     The only way to make it invisible is for the wrong state never to exist.

     So the radios are PINNED: on a size change we shadow `checked` with an
     accessor that refuses any write which would move the selection, and drop
     the shadow ~900ms later. Measured after: 130 frames sampled, 0 wrong.

     A user's own tap is unaffected - native activation sets checkedness inside
     the user agent, not through the JS property - and a trusted click in an
     option wrapper drops the pin immediately.

     THE RESTORE IS KEPT underneath as a safety net for any route the pin
     cannot cover, such as the wrapper's DOM being replaced.

     Colour is excluded deliberately: holdColour() owns it. Note that
     holdColour() is a restore of exactly the shape replaced here, so a JACKET
     is very likely still flicking on the same path.
     ==================================================================== */
  var holding = false, optGen = 0;

  var CHECKED = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "checked");
  var CAN_PIN = !!(CHECKED && CHECKED.get && CHECKED.set);

  var pinnedInputs = null, pinTimer = null;

  function unpinOpts() {
    if (pinTimer) { clearTimeout(pinTimer); pinTimer = null; }
    if (!pinnedInputs) return;
    pinnedInputs.forEach(function (inp) {
      try { delete inp.checked; } catch (e) {}
    });
    pinnedInputs = null;
  }

  function pinOpts(want, ms) {
    unpinOpts();
    if (!CAN_PIN) return;
    var held = [];
    want.forEach(function (pr) {
      var w = pr[0], val = pr[1];
      qa('input[type="radio"]', w).forEach(function (inp) {
        var keepOn = ((inp.value || "").trim() === val);
        try {
          Object.defineProperty(inp, "checked", {
            configurable: true,
            enumerable: true,
            get: function () { return CHECKED.get.call(this); },
            set: function (v) {
              if (holding) { CHECKED.set.call(this, v); return; }
              if (keepOn ? !v : !!v) return;
              CHECKED.set.call(this, v);
            }
          });
          held.push(inp);
        } catch (e) {}
      });
    });
    if (!held.length) return;
    pinnedInputs = held;
    pinTimer = setTimeout(unpinOpts, ms || 900);
  }

  function holdStyle() {
    document.addEventListener("change", function (e) {
      if (holding || !e.target || !e.isTrusted) return;
      var sw = sizeWrapper(), cw = colourWrapper();
      optWrappers().forEach(function (w) {
        if (w === sw || w === cw) return;
        if (w.contains(e.target)) { optGen++; unpinOpts(); }
      });
    }, true);

    document.addEventListener("click", function (e) {
      if (!pinnedInputs || holding || !e.isTrusted || !e.target) return;
      var sw = sizeWrapper(), cw = colourWrapper();
      var hit = optWrappers().some(function (w) {
        return w !== sw && w !== cw && w.contains(e.target);
      });
      if (hit) { optGen++; unpinOpts(); }
    }, true);

    document.addEventListener("change", function (e) {
      if (holding || !e.target) return;
      var sw = sizeWrapper();
      if (!sw || !sw.contains(e.target)) return;
      var cw = colourWrapper(), want = [];
      optWrappers().forEach(function (w) {
        if (w === sw || w === cw) return;
        var v = chosenValue(w);
        if (v) want.push([w, v]);
      });
      if (!want.length) return;

      pinOpts(want, 900);

      var gen = optGen;
      function restore() {
        if (gen !== optGen) return;
        holding = true;
        try {
          want.forEach(function (pr) {
            if (chosenValue(pr[0]) !== pr[1]) choose(pr[0], pr[1]);
          });
        } finally { holding = false; }
      }
      Promise.resolve().then(restore);
      setTimeout(restore, 0);
      setTimeout(restore, 200);
    }, true);
  }

  /* ====================================================================
     2. A SOLD-OUT VALUE IS STILL A CHOICE - EVERY RAIL, EVERY PRODUCT

     Joe, 8 Sep, about the size rail: a struck value must stay tappable,
     because tapping it is how the button below becomes Notify me.

     WIDENED 13 Sep. The first version bound only
     '.gt-bar2__row[data-row="opt"] .gt-chip'. IT COULD NOT HAVE WORKED on a
     neck tube, because which RAIL an option lands in has nothing to do with
     what the option is called:

       sizeWrapper()   = the wrapper named Size, or failing that the first
                         wrapper that is not Colour
       colourWrapper() = the wrapper named Colour
       the opt rail    = whatever is left

     So a product whose only option is Style renders that Style in the SIZE
     rail - measured on the Neck Tube, where the sold-out Chequered chip came
     up "gt-chip is-off" in data-row="size". A product whose only option is
     Colour renders in the COLOUR rail, as .gt-swatchchip. Neither was bound.

     So this binds EVERY variant rail and both chip shapes. What it will not
     touch: the Extras rows, which are Assortion add-ons and not variants, and
     .gt-chip--wide, which is the jacket armour picker.

     IT NO LONGER STOPS THE EVENT. The old version called preventDefault and
     stopPropagation so the controller's own handler could not reach its
     `if (is-off) return`. That was safe on an opt rail, where nothing else
     was listening, and would NOT be safe on the size rail, where the
     controller does real work on a tap and jackets are the money product.
     Instead every page handler runs untouched, and we simply make sure the
     selection actually landed - on a microtask, on the next frame, and once
     more at 200ms. When the normal path works, all three are no-ops.

     The generation guard means a second tap always beats a repair still in
     flight from the first.
     ==================================================================== */
  var RAILS = '.gt-bar2__row[data-row="size"],' +
              '.gt-bar2__row[data-row="colour"],' +
              '.gt-bar2__row[data-row="opt"]';

  function rowWrapper(row) {
    if (!row) return null;
    var kind = row.getAttribute("data-row");
    if (kind === "opt") return wrapperNamed(row.getAttribute("data-opt-name"));
    if (kind === "colour") return colourWrapper();
    if (kind === "size") return sizeWrapper();
    return null;
  }

  /* A chip does not always carry data-val - the colour rail draws swatches,
     which may name their value in any of several attributes. So every string
     the element offers is tried against the wrapper's REAL radio values, and
     only a match counts. If nothing matches we do nothing at all, which is
     the right failure: the page keeps whatever behaviour it already had. */
  function chipValue(chip, w) {
    if (!chip || !w) return null;
    var vals = qa('input[type="radio"]', w).map(function (i) { return (i.value || "").trim(); });
    if (!vals.length) return null;
    var cands = [], i, j;
    if (chip.dataset) {
      ["val", "value", "colour", "color", "opt", "name", "title"].forEach(function (k) {
        if (chip.dataset[k]) cands.push(chip.dataset[k]);
      });
    }
    ["data-val", "data-value", "title", "aria-label"].forEach(function (a) {
      var v = chip.getAttribute(a); if (v) cands.push(v);
    });
    var t = txt(chip); if (t) cands.push(t);
    for (i = 0; i < cands.length; i++) {
      var c = (cands[i] || "").trim();
      for (j = 0; j < vals.length; j++) if (vals[j] === c) return vals[j];
    }
    for (i = 0; i < cands.length; i++) {
      var lc = (cands[i] || "").trim().toLowerCase();
      for (j = 0; j < vals.length; j++) if (vals[j].toLowerCase() === lc) return vals[j];
    }
    return null;
  }

  function bindBarChips() {
    document.addEventListener("click", function (e) {
      if (!MQ.matches) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(".gt-bar2__exrow")) return;              /* add-ons, not variants */
      var chip = t.closest(".gt-chip, .gt-swatchchip");
      if (!chip) return;
      if (chip.classList.contains("gt-chip--wide")) return;  /* jacket armour picker */
      var row = chip.closest(RAILS);
      if (!row) return;
      var w = rowWrapper(row);
      if (!w) return;
      var val = chipValue(chip, w);
      if (!val) return;
      if (chosenValue(w) === val) return;

      /* A tap on an option we HOLD is the user overruling the hold. A tap on
         the size rail is not - that is the very change the hold exists for. */
      if (w !== sizeWrapper() && w !== colourWrapper()) { optGen++; unpinOpts(); }

      var gen = optGen;
      function ensure() {
        if (gen !== optGen) return;
        if (chosenValue(w) === val) return;
        choose(w, val);
      }
      Promise.resolve().then(ensure);
      requestAnimationFrame(ensure);
      setTimeout(ensure, 200);
    }, true);
  }

  /* ====================================================================
     2b. THE OPTION RAIL MUST TRACK THE SELECTED SIZE, BOTH WAYS

     Joe, 13 Sep, with a screenshot: M / Track Gold, ADD TO CART GBP 55.00 -
     and Track Gold, Classic Ivory and Gold & Navy all still struck through in
     the buy bar. The marks were correct - for XL, the size selected several
     taps earlier. They were never recomputed, and the version this replaces
     only ever converted is-off INTO is-gone, never back. One-way.

     NOT THE SIZE RAIL. Its .is-gone means something different on purpose -
     sizeGoneEverywhere() marks a size unavailable in EVERY combination, which
     is a static fact and correctly built once.
     ==================================================================== */
  /* is-off means DEAD - the controller's own click handler returns on it, and
     p8 styles it as unavailable-and-inert. is-gone means STRUCK BUT LIVE,
     which is the treatment Joe settled on 8 Sep.

     Converting also restores the SELECTED mark. p8 carries a rule for
     `.gt-chip.is-gone.is-on` precisely because p8 section 82.4 otherwise beats
     p5's plain `.is-on` and a struck-but-selected chip renders identically to
     an unselected one. A chip left as `is-off is-on` matches neither, so the
     shopper taps it and nothing appears to happen. */
  function markGone() {
    qa(RAILS).forEach(function (row) {
      qa(".gt-chip, .gt-swatchchip", row).forEach(function (ch) {
        if (ch.classList.contains("is-off")) {
          ch.classList.remove("is-off");
          ch.classList.add("is-gone");
        }
      });
    });
  }

  function paintOptChips() {
    if (!MQ.matches) return;
    var M = matrix();
    if (!M) return;

    qa('.gt-bar2__row[data-row="opt"]').forEach(function (row) {
      var w = wrapperNamed(row.getAttribute("data-opt-name"));
      var idx = w ? M.ws.indexOf(w) : -1;
      if (idx < 0) return;
      qa(".gt-chip", row).forEach(function (ch) {
        var val = ch.dataset ? ch.dataset.val : null;
        if (!val) return;
        var vals = M.vals.slice();
        vals[idx] = val;
        var o = comboOption(M.sel, vals);
        var gone = !o || !!o.disabled;
        if (ch.classList.contains("is-off")) ch.classList.remove("is-off");
        if (ch.classList.contains("is-gone") !== gone) ch.classList.toggle("is-gone", gone);
      });
    });
  }

  /* ====================================================================
     3. ONE TYPE SIZE PER RAIL

     fitChips() in the controller measures each chip on its own, so CHEQUERED
     and RED HERRINGBONE land at different sizes and the rail reads as ragged.
     This levels them DOWN to whichever chip needed least - down and never up,
     because the smallest is the only size every chip is known to fit.

     NOTE, measured 13 Sep: the whole rail lives inside .gt-bar2__panel, which
     is display:none while the bar is minimised, so every chip measures zero
     and neither this nor the controller's fitChips() can do anything until the
     bar is opened. Anything else that measures on build has the same blind
     spot.
     ==================================================================== */
  function evenChips() {
    if (!MQ.matches) return;
    qa(".gt-bar2__chips").forEach(function (host) {
      var chips = qa(".gt-chip", host);
      if (chips.length < 2) return;
      var min = null;
      chips.forEach(function (ch) {
        var f = parseFloat(getComputedStyle(ch).fontSize) || 0;
        if (f && (min === null || f < min)) min = f;
      });
      if (min === null) return;
      chips.forEach(function (ch) {
        var f = parseFloat(getComputedStyle(ch).fontSize) || 0;
        if (f > min + 0.01) ch.style.fontSize = min + "px";
      });
    });
  }

  /* ====================================================================
     4. THE OUT-OF-STOCK TRAFFIC LIGHT, AND THE REFLOW UNDER IT

     Impulse keeps its own inventory updater in theme.js, which rewrites this
     element on every variant change. On a sold-out variant it wrote class
     "icon-and-text inventory--low hide" and the text "Quick, only 0 left!" -
     the theme's low-stock string applied to a quantity of zero. theme.js is
     262KB and the Admin API only returns it as a CDN URL this sandbox cannot
     fetch, so re-asserting after it is the honest second best.

     THE DELAY WAS A BUG, not the colour. Joe, 13 Sep: "there is a small
     delay/reload as the OUT OF STOCK red icon section loads ... it causes the
     NOTIFY ME button to raise and then lower again." The cause was ours: the
     theme hid a 17px block, the page reflowed and painted with the button 17px
     higher, and paintInventory() only unhid it on the 90ms debounce. Switching
     between in stock and low stock never showed it because neither of those
     states is hidden - only the sold-out one was. So this runs on the FAST
     path, called straight from the MutationObserver, whose callbacks are
     delivered as microtasks BEFORE the browser paints. Measured after: 163
     frames, one single layout state, button top constant.

     THE JACKET SHOWED NOTHING AT ALL, and that was a second bug in the line
     that FINDS the element. It read `.sales-point .icon-and-text` - the FIRST
     sales point in the meta column. On a jersey that happens to be the
     inventory block. On a jacket it is not: product.men-s-jackets.json puts
     `sales_point_LiR8Jg` ("CE 'AAA' Certified EN 17092:2020") eleven places
     ahead of `inventory_status` in block_order, so every jacket had its
     certification line painted instead - harmlessly, because that line has no
     [data-product-inventory] to relabel and an icon--shield rather than
     icon--inventory to colour, which is exactly why it went unnoticed.

     So it now finds the INVENTORY block by the one attribute only the
     inventory block has, and climbs from there. snippets/product-inventory.liquid
     emits [data-product-inventory] unconditionally, so this is reliable on
     every template that has the block at all. The old selector is kept as a
     fallback for a template that somehow renders the icon without the label.

     Not gated on MQ: the dot is wrong at both widths.
     ==================================================================== */
  function soldOutNow() {
    var sel = productSelect();
    if (sel) {
      var vals = currentVals();
      if (vals.length) {
        var o = comboOption(sel, vals);
        if (o) return !!o.disabled;
      }
      var cur = sel.options && sel.options[sel.selectedIndex];
      if (cur && !optWrappers().length) return !!cur.disabled;
    }
    if (HTML.classList.contains("gt-oos")) return true;
    var b = q("[data-add-to-cart]");
    if (!b) return false;
    if (b.disabled || b.getAttribute("aria-disabled") === "true") return true;
    return /notify\s*me|sold\s*out|out of stock|unavailable/i.test(txt(b));
  }

  function paintInventory() {
    var M = meta();
    if (!M) return;
    /* The inventory block, not whichever sales point happens to come first. */
    var label = q("[data-product-inventory]", M);
    var span = label ? label.closest(".icon-and-text")
                     : q(".sales-point .icon-and-text", M);
    if (!span) return;
    var block = span.closest(".product-block--sales-point");
    if (soldOutNow()) {
      if (span.classList.contains("hide")) span.classList.remove("hide");
      if (span.classList.contains("inventory--low")) span.classList.remove("inventory--low");
      if (!span.classList.contains("inventory--out")) span.classList.add("inventory--out");
      if (block && block.classList.contains("hide")) block.classList.remove("hide");
      if (label && txt(label) !== "Out of stock") label.textContent = "Out of stock";
    } else if (span.classList.contains("inventory--out")) {
      span.classList.remove("inventory--out");
    }
  }

  /* ====================================================================
     5. THE COLLAPSED NOTIFY PANEL STILL TAKES UP ROOM

     Joe, 13 Sep: "The gap is still there on mobile between NOTIFY ME and the
     reviews. It needs to match the gap between the reviews and the trust
     icons."

     MEASURED on The Bobber Jacket, 36" / Racing Green (sold out), 375px.
     Button bottom 593, rail top 662 - a 69px gap, against 32px below the
     rail. Three things made up those 69px and only one of them was wanted:

       13px  .shsf-oos.gt-oos-below - the out-of-stock notify panel, COLLAPSED.
             Every one of its six children measures zero height, but they carry
             margin-top: 13px each, and a margin on a zero-height child still
             contributes. So the panel renders nothing and occupies 13px.
       24px  a zero-height .ast-container (Assortion's armour group, which
             product-armour.liquid hides on a jacket) carrying margin-top: 24px.
             Handled in p9 section 109.
       32px  .gt-buy's own margin-bottom. The one that was meant to be there.

     THIS FUNCTION HANDLES THE FIRST. CSS cannot ask "is this box rendering
     anything", so the measurement is done here and published as a class the
     stylesheet can use. Exactly the pattern markGone() and paintInventory()
     already follow: measure in JS, express in CSS.

     IT RE-RUNS ON EVERY PASS, which is what makes it safe. The moment the
     shopper taps Notify me and the panel fills, a child gains height, the
     class comes off on the next observer tick, and the panel's own spacing
     returns. The worst case if that tick were ever missed is a panel with
     tight internal spacing - cosmetic - rather than a panel that cannot open.

     Measured after, with p9 section 109: 32px above the rail, 32px below.
     ==================================================================== */
  /* THE SAME MEASUREMENT, FOR ASSORTION'S CONTAINER, AND IT IS A CORRECTION.

     p9 section 109 shipped a rule that zeroed `.gt-buy > .ast-container`'s
     24px top margin UNCONDITIONALLY, because on a jacket that container is
     always empty - product-armour.liquid hides the armour group - and the
     margin was dead space above the review rail.

     It is not always empty. On the GLOVES template the same container holds
     the real Leather Care add-ons, 184px of them, and that 24px is the only
     thing separating them from the availability line above. Zeroing it
     everywhere closed that gap to nothing, which is what Joe reported.
     Verified by disabling p9 on the live page: gap 24px without it, 0px with.

     So the container is measured like the notify panel is, and only a
     container that renders NOTHING loses its margin. Same rule as everywhere
     else in this file: CSS cannot ask whether a box is drawing anything, so
     JavaScript asks and publishes the answer as a class.

     THE LESSON, since this is the second time: a rule written for the shape
     of ONE template will be applied by the browser to every template that
     matches the selector. "Always empty on a jacket" is not "always empty". */
  function flattenAst() {
    qa(".gt-buy > .ast-container").forEach(function (el) {
      var empty = el.getBoundingClientRect().height === 0;
      if (el.classList.contains("gt-flat") === empty) return;
      el.classList.toggle("gt-flat", empty);
    });
  }

  function flattenOos() {
    qa(".shsf-oos").forEach(function (panel) {
      var any = false, kids = panel.children, i;
      for (i = 0; i < kids.length; i++) {
        if (kids[i].getBoundingClientRect().height > 0) { any = true; break; }
      }
      if (panel.classList.contains("gt-oos-flat") === !any) return;
      panel.classList.toggle("gt-oos-flat", !any);
    });
  }

  /* ==================================================================== */

  var t = null;

  /* ----------------------------------------------------------------------
     SECTION 10. THE FULL-SCREEN ZOOM OPENS BIGGER THAN THE SCREEN.

     Joe, 15 Sep: "On mobile, when I click a product to zoom, it opens the
     image full screen but is zoomed in too much."

     WHAT IT ACTUALLY IS, read out of theme.js rather than guessed. Impulse
     builds every PhotoSwipe item like this:

         var item = {
           msrc: el.currentSrc || el.src,
           src:  el.getAttribute("data-photoswipe-src"),
           w:    el.getAttribute("data-photoswipe-width"),
           h:    el.getAttribute("data-photoswipe-height"),
           el:   el,
           initialZoomLevel: .5
         };

     and opens the gallery with scaleMode: "zoom". Two things follow.

     initialZoomLevel is an ABSOLUTE zoom level, not a fraction of the fit. A
     hard-coded .5 knows nothing about the screen it is opening on. On a wide
     desktop .5 of a 1080px image is 540px and sits comfortably inside the
     window; on a 390px phone it is still 540px, and the shopper gets the
     middle third of the jacket.

     scaleMode: "zoom" is not one of PhotoSwipe 4's modes - they are "fit",
     "fill" and "orig" - so nothing in the library clamps the opening zoom to
     the viewport either.

     MEASURED on The Bobber Jacket at 390 x 844, first image:

       as shipped                     zoom-wrap scale 2.61, image 1018px wide
       with initialZoomLevel deleted  scale 5.22, image 2036px wide
       with this fix                  scale 1.00, image  390px wide, fits

     Deleting the property makes it WORSE, which is worth knowing before
     somebody tries it: PhotoSwipe's own default here is 1, and .5 was halving
     that. The library does compute the right number - currItem.fitRatio came
     back as 0.3611, exactly 390/1080 - it just never applies it in this mode.

     SO THE FIX IS A CLAMP, NOT A REPLACEMENT. Each item keeps whatever zoom
     level Impulse asked for unless that level would overflow the screen, in
     which case it gets the fit ratio, computed with PhotoSwipe's own formula.
     On a desktop, where .5 already fits, nothing changes at all.

     WHY NOT max-width: 100% ON THE IMAGE, which is the obvious thing to
     reach for. The size on screen comes from a transform: scale() on
     .pswp__zoom-wrap, and no max-width touches a transform. Forcing the
     image's box would also fight the library for control of pinch-zoom and
     panning, which are the whole point of the lightbox. The zoom still
     works exactly as before; it just starts where the image fits.

     w and h ARRIVE AS STRINGS, straight off the data attributes, so they are
     parsed here before use. Division coerced them well enough for
     PhotoSwipe's own maths, which is why nobody noticed.

     WRAPPING THE CONSTRUCTOR is the smallest hook that exists. The gallery is
     built fresh on every open, from inside theme.js, with no instance we can
     reach beforehand; the items array is the last thing we can touch before
     the library reads it. Correcting the zoom after the open would show the
     image at the wrong size first and then snap.

     Idempotent, and installed from fast(), which runs on the capture-phase
     click listener - so it lands before the theme's own bubble-phase handler
     constructs the gallery, even if theme.js loaded late.

     Belongs beside bindZoom() in the controller.
     ---------------------------------------------------------------------- */
  var zoomPatched = false;

  function fitZoomItems(items) {
    if (!items || !items.forEach) return;
    var vw = window.innerWidth, vh = window.innerHeight;
    if (!(vw > 0) || !(vh > 0)) return;
    items.forEach(function (it) {
      if (!it) return;
      var w = parseFloat(it.w), h = parseFloat(it.h);
      if (!(w > 0) || !(h > 0)) return;
      it.w = w;
      it.h = h;
      var fit = Math.min(vw / w, vh / h);
      if (!(it.initialZoomLevel > 0) || it.initialZoomLevel > fit) {
        it.initialZoomLevel = fit;
      }
    });
  }

  function patchZoom() {
    if (zoomPatched) return;
    var P = window.PhotoSwipe;
    if (typeof P !== "function") return;
    if (P.__gtFit) { zoomPatched = true; return; }
    function Wrapped(el, ui, items, options) {
      try { fitZoomItems(items); } catch (e) {}
      return new P(el, ui, items, options);
    }
    Wrapped.prototype = P.prototype;
    Wrapped.__gtFit = true;
    try {
      window.PhotoSwipe = Wrapped;
      zoomPatched = true;
    } catch (e) {}
  }

  /* ----------------------------------------------------------------------
     SECTION 11. THE FIRST RAIL'S HEADING NEVER CARRIED THE CHOSEN VALUE.

     Joe, 15 Sep: "on mobile when the selected variant shows a greyed out
     version of the name after the variant title (ie - size / style), this
     isn't working for SIZE on the leather belt, or style on the polyester
     neck tube. It is likely not working on other products too."

     THE SWEEP ANSWER, and it is not a list of products. It is broken on
     exactly ONE option on every product with a picker: whichever option the
     controller promotes into its first rail. Every other rail is fine.

     WHY. Charlie's 7 September change put the value in the theme's own label,
     in snippets/variant-button.liquid:

         <span class="variant__label-info">
           &mdash; <span data-gt-optvalue>{{ option.selected_value }}</span>
         </span>

     and syncOptLabels() keeps it current. That markup is present and correct
     on every rail, first one included. But buildBuy() hides the theme label
     for the rail it takes over - it writes style="display: none !important"
     onto it - and prints its own heading instead, a bare <b> inside
     .gt-buy__head carrying the option name and nothing else. So the value is
     on the page, in the right words, inside a hidden element.

     MEASURED at 390px on three products, all the same shape:

       Leather Belt    SIZE hidden, value "Small - 28\" to 32\"" present
                       LEATHER FINISH and COLOUR both fine
       Neck Tube       STYLE hidden, value "Chequered Gold" present
       Bobber Jacket   SIZE hidden, value "36\"" present, COLOUR fine

     THE FIX WRITES THE VALUE WHERE THE HEADING ACTUALLY IS, rather than
     trying to un-hide the theme label - which would fight buildBuy() for the
     same element, and on a jacket would land in a row that already carries
     FIND YOUR SIZE and the fit sentence.

     THE TREATMENT IS COPIED, NOT INVENTED. Read off the COLOUR row on the
     same page, which is the one Joe is comparing against:

       colour           rgb(122, 117, 108), which is --gt-muted #7A756C
       font-size        10.5px            --gt-t-eyebrow
       font-weight      500               against the heading's 600
       letter-spacing   1.47px            0.14em, --gt-track
       text-transform   uppercase

     Applied inline rather than from p10, deliberately: the heading is built
     by the controller and styled on the <b> itself rather than by the
     container, so nothing cascades down to a new child. One file changes
     instead of two. MOVE IT TO CSS when this file is folded into the
     controller.

     The em dash is built with fromCharCode so this file stays pure ASCII -
     working rule 18, and a literal \uXXXX escape is exactly what the
     theme-file connector mangles.

     Idempotent, and driven from fast(), so the value follows the shopper's
     choice on the same pass that repaints the chips.

     Belongs beside buildBuy() in the controller.
     ---------------------------------------------------------------------- */
  var HEAD_DASH = String.fromCharCode(8212);
  var HEADVAL_CSS =
    "font-size:var(--gt-t-eyebrow,10.5px);" +
    "font-weight:500;" +
    "letter-spacing:var(--gt-track,.14em);" +
    "text-transform:uppercase;" +
    "color:var(--gt-muted,#7A756C)";

  function headWrap() {
    var ws = optWrappers();
    if (!ws.length) return null;
    return sizeWrapper() || ws[0];
  }

  function paintHeadValue() {
    if (!MQ.matches) return;
    var head = q(".gt-buy__head");
    if (!head) return;
    var b = q("b", head);
    if (!b) return;
    var w = headWrap();
    var val = w ? (chosenValue(w) || "").replace(/\s+/g, " ").trim() : "";
    var span = q(".gt-headval", head);
    if (!val) {
      if (span && span.parentNode) span.parentNode.removeChild(span);
      return;
    }
    if (!span) {
      span = document.createElement("span");
      span.className = "gt-headval";
      span.style.cssText = HEADVAL_CSS;
      b.parentNode.insertBefore(span, b.nextSibling);
    }
    var want = " " + HEAD_DASH + " " + val;
    if (span.textContent !== want) span.textContent = want;
  }

  /* Anything that must land before the browser paints. Called synchronously
     from the observer and from change, so it runs inside the same task that
     mutated the DOM. Keep it cheap and keep it idempotent. */
  function fast() {
    try { patchZoom(); } catch (e) {}
    try { paintHeadValue(); } catch (e) {}
    try { paintInventory(); } catch (e) {}
    try { flattenOos(); } catch (e) {}
    try { flattenAst(); } catch (e) {}
    try { markGone(); } catch (e) {}
    try { paintOptChips(); } catch (e) {}
  }

  function pass() {
    fast();
    clearTimeout(t);
    t = setTimeout(function () {
      try { paintInventory(); } catch (e) {}
      try { flattenOos(); } catch (e) {}
      try { flattenAst(); } catch (e) {}
      try { markGone(); } catch (e) {}
      try { paintOptChips(); } catch (e) {}
      try { evenChips(); } catch (e) {}
    }, 90);
  }

  function start() {
    try { holdStyle(); } catch (e) {}
    try { bindBarChips(); } catch (e) {}
    pass();
    document.addEventListener("change", pass, true);
    document.addEventListener("click", pass, true);
    if (window.MutationObserver) {
      var host = q(".product-single__meta") || document.body;
      new MutationObserver(pass).observe(host, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ["class", "disabled", "aria-disabled"]
      });
      new MutationObserver(pass).observe(HTML, { attributes: true, attributeFilter: ["class"] });
      var bar = q(".gt-bar2");
      if (bar) new MutationObserver(pass).observe(bar, { childList: true, subtree: true });
    }
    [300, 800, 1600].forEach(function (d) { setTimeout(pass, d); });
    if (MQ.addEventListener) MQ.addEventListener("change", pass);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
